import { combineReducers, legacy_createStore as createStore } from 'redux';
import { createProjectReducer } from '@/features/create-project/model/createProjectSlice';
import { editorReducer } from '@/features/editor/model/editorSlice';
import { editorHistoryReducer } from '@/features/editor/model/editorHistory';
import { projectDocumentReducer } from '@/features/project-document/model/projectDocumentSlice';
import { sessionReducer } from '@/entities/session/model/sessionSlice';
/** 根 reducer 只负责组装各业务模块的状态，不承载具体编辑规则。 */
const rootReducer = combineReducers({
    editor: editorReducer,
    editorHistory: editorHistoryReducer,
    session: sessionReducer,
    createProject: createProjectReducer,
    projectDocument: projectDocumentReducer,
});
/** 创建 Redux store，测试和未来多标签页场景可据此获得隔离实例。 */
export function createEditorStore() {
    return createStore(rootReducer);
}
/** 应用全局唯一 Redux store。 */
export const editorStore = createEditorStore();
